import { ButtonGroup, IconButton, IconButtonProps } from "@mui/material";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

type ZoomControlButtonProps = {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onResetZoom: () => void;
  scale: number;
};

function ZoomButton({ sx, ...rest }: IconButtonProps) {
  return <IconButton {...rest} sx={{ ...sx, color: "white", "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.2)" } }} />;
}

export default function ZoomControlButton({ onZoomIn, onZoomOut, onResetZoom, scale }: ZoomControlButtonProps) {
  return (
    <ButtonGroup variant='contained' size='small' sx={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}>
      <ZoomButton onClick={onZoomOut} disabled={scale <= 0.25} title='Zoom Out'>
        <ZoomOutIcon fontSize='small' />
      </ZoomButton>

      <ZoomButton onClick={onResetZoom} title='Reset Zoom'>
        <RestartAltIcon fontSize='small' />
      </ZoomButton>

      <ZoomButton onClick={onZoomIn} disabled={scale >= 3.0} title='Zoom In'>
        <ZoomInIcon fontSize='small' />
      </ZoomButton>
    </ButtonGroup>
  );
}
